import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Login from '../features/Login'
import useAuth from '../hooks/useAuth'
import { Layout } from '../features/layout/Layout'
import { CampaignsPage } from '../features/campaign/CampaignPage'
import ExternalRedirect from 'presentation/features/ExternalRedirect'
import { InventoryPage } from 'presentation/features/inventory/InventoryPage'

const AppRoutes = () => {
  const { isAuthenticated, isLoading } = useAuth()
  if (isLoading) return <div>Loading...</div>
  return isAuthenticated ? (
    <Layout>
      <Routes>
        <Route
          path="/reports"
          element={
            <ExternalRedirect
              to="https://dashboard.adshines.io/dashboards"
              fallbackPath="/inventory"
            />
          }
        />
        <Route path="/inventory" element={<InventoryPage />} />
        <Route path="/campaign" element={<CampaignsPage />} />
        <Route path="*" element={<Navigate to="/inventory" replace />} />
      </Routes>
    </Layout>
  ) : (
    <Routes>
      <Route path="/*" element={<Login />} />
    </Routes>
  )
}

export default AppRoutes
